import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import Helmet from 'react-helmet';
import { composeValidators } from '../../../utils/helper';
import { resetPassword, updateUserInfo, clearState } from '../../../actionCreators/myAccount';
import { required, email, isName } from '../../../utils/validation';
import BlankLoader from '../Common/BlankLoader';
import BootstrapSuccessError from './BootstrapSuccessError';

class CustomerEdit extends Component {
  constructor(props, context) {
    super(props, context);
    const {
      dataLocale: {
        PASSWORD_HAS_BEEN_UPDATED,
        OOPS_SOMETHING_WENT_WRONG,
        YOUR_INFORMATION_UPDATED_SUCCESSFULLY,
      },
    } = this.props;
    this.state = {
      showChangePassword: false,
    };
    this.defaultValues = {
      firstName: '',
      lastName: '',
      email: '',
      gender: '',
    };
    this.previousValues = {};
    this.passwordSuccess = PASSWORD_HAS_BEEN_UPDATED;
    this.passwordFailed = OOPS_SOMETHING_WENT_WRONG;
    this.updateInfoSuccess = YOUR_INFORMATION_UPDATED_SUCCESSFULLY;
    this.updateInfoFail = OOPS_SOMETHING_WENT_WRONG;
    this.onChangePasswordClick = this.onChangePasswordClick.bind(this);
    this.onCustomerFormSubmit = this.onCustomerFormSubmit.bind(this);
  }
  componentDidMount() {
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnLoad({
        pagename: 'edit account information',
        satellite: 'account',
        subSection1: 'edit account information',
        hierarchy1: 'account edit',
      });
    }
  }
  componentDidUpdate(prevProps) {
    const { userInfoUpdated } = this.props;
    if (prevProps.userInfoUpdated !== userInfoUpdated) {
      document.scrollingElement.scrollTop = 0;
    }
  }

  componentWillUnmount() {
    this.props.clearState({ passwordReset: false, userInfoUpdated: false });
  }

  onChangePasswordClick() {
    this.setState({
      showChangePassword: !this.state.showChangePassword,
    });
  }

  onCustomerFormSubmit(values) {
    const { firstName, lastName, gender, email, oldPassword, newPassword, conPass } =
      this.previousValues;
    if (
      !(
        oldPassword === values.oldPassword &&
        newPassword === values.newPassword &&
        conPass === values.conPass
      )
    ) {
      if (values.changePassword) this.props.resetPassword(values);
    }
    if (
      !(
        firstName === values.firstName &&
        lastName === values.lastName &&
        gender === values.gender &&
        email === values.email
      )
    ) {
      this.props.updateUserInfo(values);
    }
    this.previousValues = values;
  }

  renderPasswordField({ placeHolder, input, meta }) {
    return (
      <div
        className={
          meta.touched && meta.error
            ? 'has-error col-md-12 no-padding margin-t10 margin-b5 no-padding'
            : 'col-md-12 no-padding margin-t10 margin-b5 no-padding'
        }
      >
        <div className="col-md-3">
          <label className="control-label">{placeHolder}</label>
        </div>
        <div className="col-md-3">
          <input className="form-control" {...input} autoComplete="off" type="password" />
          {meta.touched && meta.error && <div className="help-block with-errors">{meta.error}</div>}
        </div>
      </div>
    );
  }

  render() {
    const { userInfo, loading, userInfoUpdated, passwordReset, dataLocale } = this.props;
    if (userInfo) {
      this.defaultValues.firstName = userInfo.firstName || '';
      this.defaultValues.lastName = userInfo.lastName || '';
      this.defaultValues.gender = userInfo.gender || '';
      this.defaultValues.email = userInfo.email || '';
      this.defaultValues.changePassword = this.state.showChangePassword;
      this.previousValues = this.defaultValues;
    }
    const {
      EDIT_ACCOUNT_INFORMATION,
      ACCOUNT_INFORMATION,
      CONFIRM_NEW_PASSWORD,
      CURRENT_PASSWORD,
      NEW_PASSWORD,
      SAVE_AND_CONTINUE,
      PLEASE_ENTER_CORRECT_PASSWORD,
      SELECT,
      FIRST_NAME,
      LAST_NAME,
      EMAIL_ADDRESS,
      GENDER,
      MALE,
      FEMALE,
      CHANGE_PASSWORD,
    } = dataLocale;
    return (
      <React.Fragment>
        <Helmet title={ACCOUNT_INFORMATION} />
        <h2>{EDIT_ACCOUNT_INFORMATION}</h2>
        <h3>{ACCOUNT_INFORMATION}</h3>
        {Boolean(userInfoUpdated && userInfoUpdated.error) && (
          <BootstrapSuccessError
            message={userInfoUpdated.message || this.updateInfoFail}
            type="error"
          />
        )}
        {Boolean(userInfoUpdated) && (
          <BootstrapSuccessError message={this.updateInfoSuccess} type="success" />
        )}
        {Boolean(passwordReset && passwordReset.error) && (
          <BootstrapSuccessError
            message={passwordReset.message || this.passwordFailed}
            type="error"
          />
        )}
        {Boolean(passwordReset && passwordReset.fieldErrors) && (
          <BootstrapSuccessError
            message={passwordReset.fieldErrors[0].defaultMessage || this.passwordFailed}
            type="error"
          />
        )}
        {Boolean(passwordReset && !passwordReset.error && !passwordReset.fieldErrors) && (
          <BootstrapSuccessError message={this.passwordSuccess} type="success" />
        )}
        {Boolean(!userInfo) || loading ? (
          <BlankLoader imageStyle={{}} style={{}} />
        ) : (
          <Form
            noValidate
            autoComplete="off"
            autoCorrect="off"
            initialValues={this.defaultValues}
            render={({ handleSubmit }) => {
              return (
                <form className="form-SLA" onSubmit={handleSubmit}>
                  <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b5">
                    <Field name="firstName" validate={composeValidators(required, isName)}>
                      {({ input, meta }) => (
                        <div
                          className={
                            meta.touched && meta.error
                              ? 'has-error col-md-3 no-padding'
                              : 'col-md-3 no-padding'
                          }
                        >
                          <label className="control-label">{FIRST_NAME}</label>
                          <input
                            className="form-control"
                            {...input}
                            autoComplete="off"
                            type="text"
                          />
                          {meta.touched && meta.error && (
                            <div className="help-block with-errors">{meta.error}</div>
                          )}
                        </div>
                      )}
                    </Field>
                    <Field name="lastName" validate={composeValidators(required, isName)}>
                      {({ input, meta }) => (
                        <div
                          className={meta.touched && meta.error ? 'has-error col-md-3' : 'col-md-3'}
                        >
                          <label className="control-label">{LAST_NAME}</label>
                          <input
                            className="form-control"
                            {...input}
                            autoComplete="off"
                            type="text"
                          />
                          {meta.touched && meta.error && (
                            <div className="help-block with-errors">{meta.error}</div>
                          )}
                        </div>
                      )}
                    </Field>
                  </div>
                  {userInfo && userInfo.email && userInfo.email?.indexOf('lenskartomni.com') === -1 && (
                    <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b5">
                      <Field name="email" validate={composeValidators(required, email)}>
                        {({ input, meta }) => (
                          <div
                            className={
                              meta.touched && meta.error
                                ? 'has-error col-md-3 no-padding'
                                : 'col-md-3 no-padding'
                            }
                          >
                            <label className="control-label">{EMAIL_ADDRESS}</label>
                            <input
                              className="form-control"
                              {...input}
                              readOnly
                              autoComplete="off"
                              type="email"
                            />
                            {meta.touched && meta.error && (
                              <div className="help-block with-errors">{meta.error}</div>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  )}
                  <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b5">
                    <div className="col-md-3 no-padding">
                      <Field
                        defaultValue="male"
                        name="gender"
                        validate={composeValidators(required)}
                      >
                        {({ input, meta }) => (
                          <div className={meta.touched && meta.error ? 'has-error' : ''}>
                            <label className="control-label">{GENDER}</label>
                            <select className="form-control" {...input}>
                              <option value="">{SELECT}</option>
                              <option value="male">{MALE}</option>
                              <option value="female">{FEMALE}</option>
                            </select>
                            {meta.touched && meta.error && (
                              <div className="help-block with-errors">{meta.error}</div>
                            )}
                          </div>
                        )}
                      </Field>
                      <Field name="changePassword" type="checkbox">
                        {({ input, meta }) => (
                          <div
                            className={
                              meta.touched && meta.error
                                ? 'has-error margin-t10 no-padding'
                                : 'margin-t10 no-padding'
                            }
                          >
                            <label className="checkbox-inline">
                              <input
                                autoComplete="off"
                                type="checkbox"
                                onClick={this.onChangePasswordClick}
                                {...input}
                              />{' '}
                              {CHANGE_PASSWORD}
                            </label>
                            {meta.touched && meta.error && (
                              <div className="help-block with-errors">{meta.error}</div>
                            )}
                          </div>
                        )}
                      </Field>
                    </div>
                  </div>

                  {this.state.showChangePassword && (
                    <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b5">
                      <Field name="oldPassword" validate={composeValidators(required)}>
                        {({ input, meta }) =>
                          this.renderPasswordField({ placeHolder: CURRENT_PASSWORD, input, meta })
                        }
                      </Field>
                      <Field name="newPassword" validate={composeValidators(required)}>
                        {({ input, meta }) =>
                          this.renderPasswordField({ placeHolder: NEW_PASSWORD, input, meta })
                        }
                      </Field>
                      <Field name="conPass" validate={composeValidators(required)}>
                        {({ input, meta }) =>
                          this.renderPasswordField({
                            placeHolder: CONFIRM_NEW_PASSWORD,
                            input,
                            meta,
                          })
                        }
                      </Field>
                    </div>
                  )}
                  <div className="col-sm-12 margin-t20">
                    <div className="padding-t20" style={{ borderTop: '1px dashed #ccc' }}>
                      <button
                        className="btn-submit btn btn-primary col-sm-3"
                        disabled={loading}
                        type="submit"
                      >
                        {SAVE_AND_CONTINUE}
                      </button>
                    </div>
                  </div>
                </form>
              );
            }}
            validate={values => {
              const errors = {};
              if (values.conPass !== values.newPassword) {
                errors.conPass = PLEASE_ENTER_CORRECT_PASSWORD;
              }
              return errors;
            }}
            onSubmit={this.onCustomerFormSubmit}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  userInfo: state.common.userInfo.result,
  loading: state.myAccount.loading,
  passwordReset: state.myAccount.passwordReset,
  userInfoUpdated: state.myAccount.userInfoUpdated,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    resetPassword: values => dispatch(resetPassword(values)),
    updateUserInfo: values => dispatch(updateUserInfo(values)),
    clearState: values => dispatch(clearState(values)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerEdit);
